import { useId, type JSX, type ReactNode } from 'react';

import { cardClass, hintClass } from './styles.ts';

export interface CardProps {
  readonly title: string;
  /** One line under the heading, saying what the card is for. */
  readonly description?: ReactNode;
  /** A link or control belonging to the heading, such as "See all". */
  readonly actions?: ReactNode;
  readonly children: ReactNode;
}

/** A titled surface, labelled by its heading for assistive technology. */
export function Card({ title, description, actions, children }: CardProps): JSX.Element {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className={`${cardClass} flex flex-col gap-4`}>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h2 id={headingId} className="text-lg font-semibold tracking-tight">
          {title}
        </h2>
        {actions}
      </div>
      {description === undefined ? null : <p className={hintClass}>{description}</p>}
      {children}
    </section>
  );
}
